module.exports = __webpack_public_path__ + "static/media/welcome-logo.90280afa.png";